const FacebookIcon = ({ size = 24 }) => {
  return (
    <img
      src={require("../../../assets/images/facebook.svg").default}
      alt="facebook"
      width={size}
    />
  );
};

export default FacebookIcon;
